import HelpTooltip from './HelpTooltip';

const HelpTooltipFormLabel = ({label, help, markdown, ...props}) => (
  <span>
    <span>{label}</span>
    <HelpTooltip title={help} markdown={markdown} {...props}/>
  </span>
);

export default HelpTooltipFormLabel;
